import { FixtureTypes } from './constants';

export const isMeratusTcOut = (
	hasMeratusFlag: boolean,
	fixtureType: string,
) => hasMeratusFlag && fixtureType === FixtureTypes.TC_OUT;

export const isMeratusTcInOrOut = (
	hasMeratusFlag: boolean,
	fixtureType: string,
) => hasMeratusFlag && (
	fixtureType === FixtureTypes.TC_OUT ||
	fixtureType === FixtureTypes.TC_IN
);

export const MeratusExpenseSubjectToHireDaysAccountCodes = {
	communicationAllowances: {
		label: 'Communication allowances subject to Hire Days',
		accountCode: '5.115.04',
	},
	entertainmentAllowances: {
		label: 'Entertainment allowances subject to Hire Days',
		accountCode: '5.115.05',
	},
	lashingAllowances: {
		label: 'Lashing allowances subject to Hire Days',
		accountCode: '5.105.01',
	},
} as const;

export const MeratusRevenueSubjectToDaysAccountCodes = {
	sundriesGeneral: {
		label: 'Sundries / General Expenses',
		accountCode: '5.900.99',
	},
	agencyRevenue: {
		label: 'Agency Revenue',
		accountCode: '4.201.27',
	},
	managementFee: {
		label: 'Management Fee',
		accountCode: '4.201.26',
	},
} as const;

export const MeratusChartererExpenseAccountCodes = MeratusRevenueSubjectToDaysAccountCodes;

type MeratusAccountCodeConfig = {
	label: string;
	accountCode: string;
};

export const getMeratusAccountCodeOptions = (
	config: Record<string, MeratusAccountCodeConfig>,
) => {
	return Object.values(config).map(({ label, accountCode }) => ({
		label: `${label} (${accountCode})`,
		value: accountCode,
	}));
};

export const getMeratusAccountCodeLabel = (
	accountCode: string | null | undefined,
	config: Record<string, MeratusAccountCodeConfig>,
): string | undefined => {
	if (accountCode == null) {
		return undefined;
	}

	const match = Object.values(config).find((c) => c.accountCode === accountCode);

	return match?.label;
};

export const isMeratusAccountCodeAllowed = (
	accountCode: string | null | undefined,
	config: Record<string, MeratusAccountCodeConfig>,
): boolean => {
	if (accountCode == null) {
		return false;
	}

	return Object.values(config).some((c) => c.accountCode === accountCode);
};

export const resolveMeratusCveAccountCodeOverride = (
	accountCodeOverride?: string | null,
	name?: string | null,
): string | undefined => {
	if (isMeratusAccountCodeAllowed(
		accountCodeOverride,
		MeratusExpenseSubjectToHireDaysAccountCodes,
	)) {
		return accountCodeOverride ?? undefined;
	}

	if (name == null) {
		return undefined;
	}

	const match = Object.values(MeratusExpenseSubjectToHireDaysAccountCodes)
		.find((config) => config.label === name);

	return match?.accountCode;
};
